module.exports = __webpack_public_path__ + "img/functionality.3f85819d.jpeg";